import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {withProps} from '/util/selector.util';

import ClientInformation from './ClientInformation';

export default connect(
  createStructuredSelector({
    featureFlag: variablesFeatureFlag,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
)(ClientInformation);
